const state = {
    detalle:{}
}

const getters = {
    detalle: state => state.detalle
}

const mutations = {
    setDetalle(state, payload){
        state.detalle = payload
    }
}

export default {
    namespaced: true,
    state,
    getters,
    mutations
}